import React from 'react';

/** Сердце для избранного: контур, пока не в избранном; заливка — после добавления (currentColor из кнопки). */
export function FavoriteHeartIcon({ filled }: { filled: boolean }) {
  return (
    <svg
      className="fc-favorite-heart-icon"
      viewBox="0 0 24 24"
      width={20}
      height={20}
      aria-hidden
    >
      <path
        fill={filled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={filled ? 0 : 1.85}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.5 4.04 3 5.5l7 7Z"
      />
    </svg>
  );
}
